import React from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../shared/utils/translationUtils";
import "./style.less";

interface MapErrorOverlayProps {
  messageKey?: string;
  message?: string;
}

const MapErrorOverlay: React.FC<MapErrorOverlayProps> = ({
  messageKey = "newTrial.trialMap.unavailable",
  message,
}) => {
  const { t } = useTranslation();
  const text = message ?? formatTranslation(t(messageKey));

  return (
    <div
      data-testid="map-error-overlay"
      className="map-error-overlay"
      role="alert"
    >
      <p className="map-error-overlay__text">{text}</p>
    </div>
  );
};

export default MapErrorOverlay;
